function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgDonationsTelegram = function SvgDonationsTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2959 18C36.2959 27.9411 28.237 36 18.2959 36C8.35477 36 0.295898 27.9411 0.295898 18C0.295898 8.05888 8.35477 0 18.2959 0C28.237 0 36.2959 8.05888 36.2959 18ZM18.9409 13.2884C17.1902 14.0166 13.6911 15.5238 8.44374 17.81C7.59165 18.1488 7.14528 18.4803 7.10465 18.8045C7.03598 19.3522 7.72196 19.5679 8.6561 19.8617C8.78317 19.9016 8.91483 19.943 9.0498 19.9869C9.96885 20.2857 11.2051 20.6352 11.8478 20.649C12.4308 20.6616 13.0815 20.4213 13.7999 19.928C18.7026 16.6185 21.2335 14.9457 21.3924 14.9097C21.5045 14.8842 21.6598 14.8522 21.765 14.9458C21.8703 15.0393 21.8599 15.2165 21.8488 15.264C21.7808 15.5537 19.0881 18.0571 17.6946 19.3527C17.2602 19.7565 16.952 20.043 16.889 20.1085C16.7479 20.255 16.6041 20.3937 16.4659 20.5269C15.612 21.35 14.9718 21.9672 16.5013 22.9752C17.2364 23.4596 17.8245 23.8601 18.4113 24.2597C19.0522 24.6961 19.6913 25.1314 20.5183 25.6735C20.729 25.8116 20.9302 25.9551 21.1262 26.0948C21.872 26.6265 22.542 27.1041 23.3698 27.0279C23.8508 26.9837 24.3476 26.5314 24.5999 25.1825C25.1962 21.9947 26.3683 15.0877 26.6392 12.2415C26.663 11.9921 26.6331 11.673 26.6091 11.5329C26.5852 11.3928 26.535 11.1932 26.3529 11.0454C26.1373 10.8704 25.8043 10.8335 25.6554 10.8361C24.9784 10.8481 23.9397 11.2092 18.9409 13.2884Z",
    fill: "#6B6B70"
  }));
};
export default SvgDonationsTelegram;